import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { APIService } from "./apiservices";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const isValid = APIService.hasValidSession();
    if (isValid) return true;

    if (APIService.userLogin?.expirationDate) {
      APIService.clearAuthSession();
    }

    return this.router.createUrlTree(['/auth'], {
      queryParams: { returnUrl: state.url },
    });
  }
}
